import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15 1.956v1.667M5 1.956v1.667"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9.997 11.123h.007m-.007 3.333h.007m3.322-3.333h.008m-6.667 0h.007m-.007 3.333h.007"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.917 6.956h14.167m-15 3.536c0-3.631 0-5.447 1.043-6.575S5.85 2.79 9.209 2.79h1.583c3.359 0 5.038 0 6.081 1.128s1.044 2.944 1.044 6.575v.428c0 3.63 0 5.446-1.044 6.574-1.043 1.128-2.722 1.128-6.081 1.128H9.209c-3.36 0-5.039 0-6.082-1.128s-1.043-2.943-1.043-6.574zM2.5 6.956h15"
    }, null, -1)
  ]))]))
}
export default { render: render }